import { callApi } from '@local_modules/generic/fetch'
import dayjs from 'dayjs'

/**
 *
 * @param {String} accountingOrganisationId
 * @returns {Array<Object>}
 */
export default async function loadFinancialStatement (accountingOrganisationId) {
  const apiEndpoint = '/api/pg-financials/data/:accountingOrganisationId/pg-statement-values/:monthFrom/:monthTo/:currencyCode'

  const apiData = await callApi(apiEndpoint, {
    accountingOrganisationId,
    monthFrom: dayjs().subtract(12, 'month').format('YYYY-MM'),
    monthTo: dayjs().format('YYYY-MM'),
    currencyCode: 'XXX'
  })
  console.log('loadFinancialStatement', apiData)

  const financials = analyseFinancialStatement(apiData)
  console.log('financials', financials)

  const data = {
    apiData,
    analysedFinancials: financials
  }

  return data
}

function analyseFinancialStatement (financialStatement) {
  console.log('analyseFinancialStatement', financialStatement)

  const financialStatementData = financialStatement.convertedValuesResults?.convertedValues

  const financials = {
    month: new Set(),
    byAccountingChartOfAccountId: new Map(),
    byMonth: new Map()
  }

  financialStatementData.forEach(d => {
    const monthYYYYMM = dayjs(d.month).format('YYYY-MM')

    financials.month.add(monthYYYYMM)

    if (!financials.byAccountingChartOfAccountId.has(d.accounting_chart_of_account_id)) {
      financials.byAccountingChartOfAccountId.set(d.accounting_chart_of_account_id, {
        values: [],
        byMonth: new Map(),
        totalAmount: 0
      })
    }
    financials.byAccountingChartOfAccountId.get(d.accounting_chart_of_account_id).values.push(d)
    financials.byAccountingChartOfAccountId.get(d.accounting_chart_of_account_id).totalAmount += d.valuePeriod

    if (!financials.byAccountingChartOfAccountId.get(d.accounting_chart_of_account_id).byMonth.has(monthYYYYMM)) {
      financials.byAccountingChartOfAccountId.get(d.accounting_chart_of_account_id).byMonth.set(monthYYYYMM, {
        values: [],
        totalAmount: 0
      })
    }

    financials.byAccountingChartOfAccountId.get(d.accounting_chart_of_account_id).byMonth.get(monthYYYYMM).values.push(d)
    financials.byAccountingChartOfAccountId.get(d.accounting_chart_of_account_id).byMonth.get(monthYYYYMM).totalAmount += d.valuePeriod

    if (!financials.byMonth.has(monthYYYYMM)) {
      financials.byMonth.set(monthYYYYMM, {
        values: [],
        totalAmount: 0
      })
    }
    financials.byMonth.get(monthYYYYMM).values.push(d)
    financials.byMonth.get(monthYYYYMM).totalAmount += d.valuePeriod
  })

  return financials
}
